export const productsSelect = [
  {id: 'ios', label: 'iOS'},
  {id: 'android', label: 'Android'},
  {id: 'web', label: 'Web'},
  {id: 'sms', label: 'SMS'},
  {id: 'email', label: 'Email'},
  {id: 'open_channels', label: 'Open Channel'},
  {id: 'message_center', label: 'Message Center'},
  {id: 'wallet', label: 'Wallet'},
  {id: 'push_notification', label: 'Push Notification'},
  {id: 'automation', label: 'Automation'},
  {id: 'inapp_automation', label: 'In-App Automation'},
  {id: 'journey', label: 'Sequences'},
  {id: 'segmentation', label: 'Segments'},
  {id: 'lists', label: 'Lists'},
  {id: 'report', label: 'Report'},
  {id: 'performance_analytics_', label: 'Performance Analytics'},
  {id: 'realTimeDataStreaming', label: 'Real-Time Data Streaming'},
  {id: 'dashboard_', label: 'Dashboard'},
  {id: 'api', label: 'API'},
  {id: 'sdk', label: 'SDK'},
  {id: 'other', label: 'Other'},
] as const
